import { useEffect, useState } from 'react';

/** Horloge qui se met à jour toutes les `intervalMs` — même idiome que le tick d'UI Live School. */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
